import produce from "immer";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchProjects,
  fetchProject,
  updateProject,
  createProject,
  deleteProject,
} from "../api/project";

const initialState = {
  isLoading: false,
  error: false,
  errors: null,
  data: [],
  totalCount: 0,
  currentCount: 0,
  newCount: 0,
};

export const initialController = {
  filters: [],
  page: 0,
  query: "",
  sort: "desc",
  sortBy: "created_at",
  view: "all",
};

export const deleteProjectAsync = createAsyncThunk(
  "projects/deleteProjectAsync",
  async (payload) => {
    let response = await deleteProject(payload);

    // If errors, reject and return response
    if (response.error) return false;

    // If all good, return response.
    return response;
  }
);

export const createProjectAsync = createAsyncThunk(
  "projects/createProjectAsync",
  async (payload) => {
    let response = await createProject(payload);

    // If errors, reject and return response
    if (response.error) return false;

    // If all good, return response.
    return response;
  }
);

export const updateProjectAsync = createAsyncThunk(
  "projects/updateProjectAsync",
  async (payload) => {
    let response = await updateProject(payload);

    // If errors, reject and return response
    if (response.error) return false;

    // If all good, return response.
    return response;
  }
);
export const getProjectsAsync = createAsyncThunk(
  "projects/getProjectsAsync",
  async (controller = initialController, { rejectWithValue }) => {
    // if (! controller) return false;
    let response = await fetchProjects(controller);
    // If errors, reject and return response
    if (response.response?.status?.match(/404|500|401/))
      return rejectWithValue(true);

    // If all good, return response.
    return response;
  }
);

export const getProjectAsync = createAsyncThunk(
  "projects/getProjectAsync",
  async (id, { rejectWithValue }) => {
    // if (! controller) return false;
    let response = await fetchProject(id);

    // If errors, reject and return response
    if (response.error) return rejectWithValue(response);

    // If all good, return response.
    return response;
  }
);

const projectSlice = createSlice({
  name: "projects",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getProjectsAsync.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getProjectsAsync.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload.data;
        state.totalCount = action.payload.totalCount;
        state.currentCount = action.payload.currentCount;
        state.newestProjectsCount = action.payload.newCount;
      })
      .addCase(getProjectsAsync.rejected, (state) => {
        state.isLoading = false;
        state.error = true;
        state.errors = [
          "Something went wrong when trying to fetch variable types....is controller missing?",
        ];
      })
      .addCase(updateProjectAsync.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateProjectAsync.fulfilled, (state, action) => {
        return produce(state, (draftState) => {
          const index = draftState.data.findIndex(
            (type) => type.id === action.payload.id
          );
          draftState.data[index] = action.payload;
          draftState.isLoading = false;
        });
      })
      .addCase(updateProjectAsync.rejected, (state) => {
        state.isLoading = false;
        state.error = true;
        state.errors = ["Something went wrong when trying to update project"];
      })
      .addCase(createProjectAsync.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createProjectAsync.fulfilled, (state, action) => {
        return produce(state, (draftState) => {
          draftState.data.push(action.payload);
          draftState.isLoading = false;
        });
      })
      .addCase(createProjectAsync.rejected, (state) => {
        state.isLoading = false;
        state.error = true;
        state.errors = ["Something went wrong when trying to update project"];
      })
      .addCase(deleteProjectAsync.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteProjectAsync.fulfilled, (state, action) => {
        return produce(state, (draftState) => {
          draftState.data = action.payload;
          draftState.isLoading = false;
        });
      })
      .addCase(deleteProjectAsync.rejected, (state) => {
        state.isLoading = false;
        state.error = true;
        state.errors = ["Something went wrong when trying to update project"];
      })
      .addCase(getProjectAsync.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getProjectAsync.fulfilled, (state, action) => {
        return produce(state, (draftState) => {
          draftState.project = action.payload;
          draftState.isLoading = false;
        });
      })
      .addCase(getProjectAsync.rejected, (state) => {
        state.isLoading = false;
        state.error = true;
        state.errors = ["Something went wrong when trying to update product."];
      });
  },
});

// export const {} = customerSlice.actions;

export const { reducer } = projectSlice;

export default projectSlice;
